export default {
    ADD_TRANSACTION: 'ADD_TRANSACTION',
    EDIT_TRANSACTION: 'EDIT_TRANSACTION',
    DELETE_TRANSACTION: 'DELETE_TRANSACTION',
    ADD_NESTEDTRANSACTION: 'ADD_NESTEDTRANSACTION',
    DELETE_NESTEDTRANSACTION: 'DELETE_NESTEDTRANSACTION',
    DELETE_NESTEDTRANSACTION_LINK: 'DELETE_NESTEDTRANSACTION_LINK',
    ADD_INVOKEDTRANSACTION: 'ADD_INVOKEDTRANSACTION',
    EDIT_INVOKEDTRANSACTION: 'EDIT_INVOKEDTRANSACTION',
    DELETE_INVOKEDTRANSACTION: 'DELETE_INVOKEDTRANSACTION',
    REORDER_CLUSTERLETS: 'REORDER_CLUSTERLETS',
    ADD_EVENT_TO_TRANSACTION: 'ADD_EVENT_TO_TRANSACTION',
    DELETE_EVENT_FROM_TRANSACTION: 'DELETE_EVENT_FROM_TRANSACTION',
    UPDATE_FULL_TRANSACTIONS: 'UPDATE_FULL_TRANSACTIONS',
    EDIT_NESTEDTRANSACTION: 'EDIT_NESTEDTRANSACTION',
    ADD_TEMPLATE_TRANSACTION: 'ADD_TEMPLATE_TRANSACTION',
    DELETE_TEMPLATE_TRANSACTION: 'DELETE_TEMPLATE_TRANSACTION',
    REMOVE_TEMPLATE_TRANSACTION: 'REMOVE_TEMPLATE_TRANSACTION',
    ADD_CLUSTERLET_TO_TRANSACTION: 'ADD_CLUSTERLET_TO_TRANSACTION',
    REMOVE_CLUSTERLET_FROM_TRANSACTION: 'REMOVE_CLUSTERLET_FROM_TRANSACTION',
    RESET_TRANSACTIONS: 'RESET_TRANSACTIONS',
    EDIT_EVENT_ORDER: 'EDIT_EVENT_ORDER'
}